import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@store';
import { ViError } from '@vi-iot/client';
import { Observable } from 'rxjs';
import { TutorialsActions } from './tutorials.actions';
import { TutorialsData, TutorialType } from './tutorials.model';
import { TutorialsSelectors } from './tutorials.selectors';
import { TutorialsState } from './tutorials.state';

@Injectable({ providedIn: 'root' })
export class TutorialsStore {
  state$: Observable<TutorialsState> = this.store$.select(TutorialsSelectors.getState());
  tutorials$: Observable<TutorialsData[]> = this.store$.select(TutorialsSelectors.getTutorials);
  loading$: Observable<boolean> = this.store$.select(TutorialsSelectors.getLoading);
  loaded$: Observable<boolean> = this.store$.select(TutorialsSelectors.getLoaded);
  saving$: Observable<boolean> = this.store$.select(TutorialsSelectors.getSaving);
  saved$: Observable<boolean> = this.store$.select(TutorialsSelectors.getSaved);
  error$: Observable<ViError> = this.store$.select(TutorialsSelectors.getError);
  displayKanbanInstallationsListTutorial$: Observable<boolean> = this.store$.select(
    TutorialsSelectors.selectDisplayKanbanInstallationsListTutorial
  );
  displayKanbanBoardTutorial$: Observable<boolean> = this.store$.select(
    TutorialsSelectors.selectDisplayKanbanBoardTutorial
  );
  displayLandingPageTutorial$: Observable<boolean> = this.store$.select(
    TutorialsSelectors.selectDisplayLandingPageTutorial
  );

  fetchTutorials(): void {
    this.store$.dispatch(TutorialsActions.fetchTutorials.attempt());
  }

  resetTutorial(tutorialType: TutorialType): void {
    this.store$.dispatch(TutorialsActions.resetTutorial({ tutorialType }));
  }

  markTutorialAsPresented(tutorialType: TutorialType): void {
    this.store$.dispatch(TutorialsActions.markAsPresented({ tutorialType }));
  }

  hasTutorialBeenPresented(tutorialType: TutorialType): Observable<boolean> {
    return this.store$.select(TutorialsSelectors.hasTutorialBeenPresented(tutorialType));
  }

  constructor(private store$: Store<AppState>) {}
}
